import { Box } from "@mui/material";

interface ImagesDialogProps {
  images: string[];
  selectedImage: number;
  setSelectedImage: (index: number | null) => void;
}

const ImagesDialog = ({
  images,
  selectedImage,
  setSelectedImage,
}: ImagesDialogProps) => {
  return (
    <Box
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center"
      onClick={() => setSelectedImage(null)}
    >
      <Box
        className="relative max-w-4xl w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={images[selectedImage]}
          alt={`Imagen ${selectedImage + 1}`}
          className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-lg"
        />
      </Box>
    </Box>
  );
};

export default ImagesDialog;
